import { takeEvery, fork, put, all, call } from "redux-saga/effects";

import {
  apiError,
  getShowrooms,
  showroomsListSuccessful,
  showroomsAddSuccessful,
  isModelVisible,
} from "./showroomsSlice";

// AUTH related methods
import {
  postAdd,
  getParamsList,
  postEdit,
  postDelete,
} from "../../../helpers/Helper";
import { Modal } from "antd";
import {
  RiCheckboxCircleLine,
  RiAlertLine,
  RiInformationLine,
} from "react-icons/ri";

function* getShowroom({ payload }) {
  var data = payload;
  var params = {};

  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (k === "currentSort" || k === "sortOrder") {
        params.ordering = data.sortOrder + data.currentSort;
      } else {
        if (data[k] != "" && k != null && k != "no_of_pages") {
          params[k] = data[k];
        }
      }
    }
  }
  try {
    const response = yield call(getParamsList, "/masters/showrooms/", params);
    yield put(showroomsListSuccessful({ response }));
  } catch (error) {
    yield put(apiError(error));
  }
}
function* AddShowrooms({ payload }) {
  try {
    if (payload.id == 0) {
      const response = yield call(postAdd, "/masters/showrooms/", payload);
      if (response.status === 201) {
        Modal.success({
          icon: (
            <span className="remix-icon">
              <RiCheckboxCircleLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Your Show Room Add Successfully.!
              </p>
            </div>
          ),
        });
        yield put(getShowrooms({ page: 1, search: "", page_size: 10 }));
        yield put(isModelVisible(false));
      } else {
        Modal.error({
          icon: (
            <span className="remix-icon">
              <RiAlertLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Sorry! Unable to added Show Room. Please try again!
              </p>
            </div>
          ),
        });
      }
      yield put(showroomsAddSuccessful(null));
    } else {
      const response = yield call(
        postEdit,
        "/masters/showrooms/" + payload.id,
        payload
      );
      if (response.status === 200) {
        Modal.success({
          icon: (
            <span className="remix-icon">
              <RiCheckboxCircleLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Your Show Room Edited Successfully.!
              </p>
            </div>
          ),
        });
        yield put(getShowrooms({ page: 1, search: "", page_size: 10 }));
        yield put(isModelVisible(false));
      } else {
        Modal.error({
          icon: (
            <span className="remix-icon">
              <RiAlertLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Sorry! Unable to edit Show Room. Please try again!
              </p>
            </div>
          ),
        });
      }
      yield put(showroomsAddSuccessful(null));
    }
  } catch (error) {
    Modal.error({
      icon: (
        <span className="remix-icon">
          <RiAlertLine />
        </span>
      ),

      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: (
        <div>
          <p className="hp-p1-body hp-text-color-black-80">
            Sorry! Getting from server side issue!
          </p>
        </div>
      ),
    });
    yield put(apiError(error));
  }
}

function* DeleteShowrooms({ payload }) {
  var countryID = payload;
  try {
    const response = yield call(postDelete, "/masters/showrooms/" + countryID);

    if (response.status === 204) {
      Modal.success({
        icon: (
          <span className="remix-icon">
            <RiCheckboxCircleLine />
          </span>
        ),
        title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
        content: (
          <div>
            <p className="hp-p1-body hp-text-color-black-80">
              Your Show Room has been deleted!
            </p>
          </div>
        ),
      });
      yield put(getShowrooms({ page: 1, search: "", page_size: 10 }));
    } else {
      Modal.error({
        icon: (
          <span className="remix-icon">
            <RiAlertLine />
          </span>
        ),
        title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
        content: (
          <div>
            <p className="hp-p1-body hp-text-color-black-80">
              Sorry! Your Show Room has been not deleted!
            </p>
          </div>
        ),
      });
    }
  } catch (error) {
    Modal.error({
      icon: (
        <span className="remix-icon">
          <RiAlertLine />
        </span>
      ),

      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: (
        <div>
          <p className="hp-p1-body hp-text-color-black-80">
            Sorry! Getting from server side issue!
          </p>
        </div>
      ),
    });


    yield put(apiError(error));
  }
}

export function* watchgetShowrooms() {
  yield takeEvery("showrooms/getShowrooms", getShowroom);
}
export function* watchShowroomsAdd() {
  yield takeEvery("showrooms/showroomsAdd", AddShowrooms);
}

export function* watchShowroomsDelete() {
  yield takeEvery("showrooms/showroomsDelete", DeleteShowrooms);
}

function* ShowroomsSaga() {
  yield all([fork(watchgetShowrooms), fork(watchShowroomsAdd), fork(watchShowroomsDelete)]);
}

export default ShowroomsSaga;
